import { useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { StageGetSummaryCollectionByProjectId, StageGetSummaryCollectionByProjectIdResponse } from '../../api/dtos';

const getData = (response?: SWRResponse<StageGetSummaryCollectionByProjectIdResponse, StageGetSummaryCollectionByProjectIdResponse>) => {
    return response?.data?.stageSummaries
}
const getError = (response?: SWRResponse<StageGetSummaryCollectionByProjectIdResponse, StageGetSummaryCollectionByProjectIdResponse>) => (response?.error ?? response?.data)?.responseStatus;
// const getAdditionalState = (response?: SWRResponse<StageGetSummaryCollectionByProjectIdResponse, StageGetSummaryCollectionByProjectIdResponse>) => ({});

const useStageSummariesByProjectId = (projectId: number, showArchivedStages: boolean, configuration?: SWRConfiguration<StageGetSummaryCollectionByProjectIdResponse, StageGetSummaryCollectionByProjectIdResponse>) => {
    
    const request = useMemo(() => {
        return () => {
            return new StageGetSummaryCollectionByProjectId({
                projectId: projectId, 
                showArchivedStages: showArchivedStages
            });
        };
    }, [projectId, showArchivedStages])

    return useGet(request, { getData, getError }, configuration);
}

export default useStageSummariesByProjectId;